var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 47,
    viewBox: "0 0 59 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.3087 8.61685L56.2973 8.62929L56.2868 8.64247L27.8698 44.1815C27.4292 44.6526 26.8988 45.031 26.3097 45.2944C25.7152 45.5602 25.0732 45.7035 24.4221 45.7155C23.771 45.7276 23.1241 45.6082 22.5201 45.3646C21.9162 45.1209 21.3676 44.758 20.9071 44.2974L20.9071 44.2974L2.05435 25.4447L2.04811 25.4384L2.04166 25.4324C1.56576 24.989 1.18406 24.4542 0.919323 23.8601C0.654583 23.2659 0.512229 22.6245 0.500754 21.9741C0.489279 21.3238 0.608919 20.6777 0.852534 20.0746C1.09615 19.4715 1.45875 18.9236 1.9187 18.4636C2.37866 18.0037 2.92654 17.6411 3.52967 17.3975C4.13281 17.1538 4.77883 17.0342 5.4292 17.0457C6.07957 17.0572 6.72097 17.1995 7.31514 17.4642C7.9093 17.729 8.44405 18.1107 8.88749 18.5866L8.89355 18.5931L8.89983 18.5994L23.8196 33.512L24.2183 33.9105L24.5664 33.467L49.3042 1.94818L49.4156 1.8192C50.3234 0.963427 51.5267 0.490695 52.7748 0.500139C54.0309 0.509643 55.2342 1.00674 56.1308 1.88654C57.0273 2.76635 57.547 3.96003 57.5802 5.21573C57.6134 6.47142 57.1575 7.6909 56.3087 8.61685Z",
    stroke: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector-2.436784ba309765bf6dc4b5c10525af36.svg";
export { ForwardRef as ReactComponent };